/**
 * Stytch SMS OTP Creation Hook
 *
 * This hook provides functionality for creating TOTP (Time-based One-Time Password)
 * authentication using the Stytch B2B headless client.
 */
import { useCallback } from 'react';
import { getStytchClient } from '../../../../adapters/react/client/headless-client';
export function useStytchSmsOtpSend() {
    return useCallback(async (data) => {
        const stytch = getStytchClient();
        if (!stytch) {
            return {
                success: false,
                error: 'Stytch client not ready',
                data: null,
            };
        }
        try {
            const result = await stytch.otps.sms.send({
                member_id: data.memberId,
                organization_id: data.organizationId,
                mfa_phone_number: data.mfaPhoneNumber,
                locale: data.locale,
            });
            return {
                success: true,
                requestId: result.request_id,
                statusCode: result.status_code,
            };
        }
        catch (error) {
            const err = error;
            return {
                success: false,
                error: err.error_message || err.message || 'Failed to create SMS OTP',
                data: error,
            };
        }
    }, []);
}
export function useStytchSmsOtpAuthenticate() {
    return useCallback(async (data) => {
        const stytch = getStytchClient();
        if (!stytch) {
            return {
                success: false,
                error: 'Stytch client not ready',
                data: null,
            };
        }
        try {
            const result = await stytch.otps.sms.authenticate({
                member_id: data.memberId,
                organization_id: data.organizationId,
                code: data.code,
                session_duration_minutes: data.sessionDurationMinutes,
                set_mfa_enrollment: data.setMfaEnrollment,
            });
            return {
                success: true,
                requestId: result.request_id,
                statusCode: result.status_code,
                memberId: result.member_id,
                //organizationId: result.organization_id,
                sessionJwt: result.session_jwt,
                sessionToken: result.session_token,
                memberSession: result.member_session,
                member: result.member,
                organization: result.organization,
                // memberDevice: result.member_device,
                data: result,
            };
        }
        catch (error) {
            const err = error;
            return {
                success: false,
                error: err.error_message || err.message || 'Failed to authenticate SMS OTP',
                data: error,
            };
        }
    }, []);
}
